<div class="overdiv">
    <div class="firstView">
        <img src="./assets/img/first-pic.webp" alt="">
        <div class="spandesign">
            <span>
                <p >{{ dataJson["Slogan"] }}</p>
                <p class="Title-city">{{ dataJson["Ort"] }}</p>
            </span>
            <div class="arrow">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>


    
    <div style="width: 100%; display: flex; justify-content: center; flex-direction: column; align-items: center;">
        <div class="welcomeText">
            <h3>{{ dataJson["Ueberschrift"]}} <b><span>Osteo</span>medica</b></h3>
            <span class="textbox destop-text">
                <p style="padding: 0;margin: 0;">
                    {{ dataJson["ErsterTextBlockUeberschrift"] }}     </p>
            </span>
            <br>
            <br>
            <span class="textbox destop-text" >
                <p style="padding: 0;margin: 0;">
                    {{ dataJson["ZweiterTextBlockUeberschrift"] }}</p>
            </span>
        </div>
        <div  class="welcomeText" style=" margin-top: 30x; ">
            <h3>{{dataJson["UnserTeamUeberschrift"]}} <b><span>{{ dataJson["UnserTeamUeberschriftStyle"]}}</span></b></h3>
        </div>
        
        <div class="welcomeText">
            <!-- >Animation OLD -->
            <!-- <div class="addDestopTeam">
                class="nameBox"
                <app-show-team style="width: 100%; display: flex; align-items: center; flex-direction: column;"></app-show-team>
                <app-stefan-pre style="width: 100%; "></app-stefan-pre>
            </div> -->
            <div class="NEWWRAPPER">
                <div *ngFor="let item of names; let i = index" class="item-container" [ngStyle]="{'flex-direction': i % 2 === 0 ? 'row' : 'row-reverse'}">
                  <div class="item-content">
                    <div class="fade-up-box">
                      <img class="person-image" [src]="'./assets/img/people/' + item.image_path + '.webp'" alt="{{ item.image_path }}">
                      <div class="nameBox"><span>{{ item.name }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              
            <div class="TeamButton">
                <a aria-label="Team-Seite" routerLink="/team">{{ dataJson["TeamButton"] }}</a>
            </div>
        </div>
        <div class="welcomeText">
            <h3>{{ dataJson["UnsereLeistungenUeberschrift"]}} <b><span>{{dataJson["UnsereLeistungenUeberschriftStyle"]}}</span></b></h3>
        </div>
        <div class="welcomeText" style="width: calc(100% - 48px);display: flex; justify-content: center; align-items: center; flex-direction: column;">
            
            <div class="Main-picture-container">
                <img *ngFor="let image of images; let i = index"  
                     [src]="image" 
                     [alt]="'Image ' + i" 
                     [class.active]="i === currentImageIndex" 
                     [class.right]="imagesstyle[i] == 'right'"
                     (load)="nextImage();"
                />
                
            </div>
            <div class="nameBoxForposition"><span>{{currentText}}</span></div>
            <div class="wrapper"> 
                <div class="container">
                    <input type="radio" name="slide" id="c1" checked>
                    <label for="c1" class="card" (click)="c1()">
                        <div class="row">
                            <div class="icon"></div>
                            <div class="description">
                                <h4 *ngIf="text && text[0]">{{text[0]['name']}}</h4>
                            </div>
                        </div>
                    </label>
                    <input type="radio" name="slide" id="c2" >
                    <label for="c2" class="card" (click)="c2()">
                        <div class="row">
                            <div class="icon"></div>
                            <div class="description">
                                <h4 *ngIf="text && text[1]">{{text[1]['name']}}</h4>
                            </div>
                        </div>
                    </label>
                    <input type="radio" name="slide" id="c3" >
                    <label for="c3" class="card" (click)="c3()">
                        <div class="row">
                            <div class="icon"></div>
                            <div class="description">
                                <h4 *ngIf="text && text[2]">{{text[2]['name']}}</h4>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
            <div class="TeamButton">
                <a aria-label="Unsere-Leistungen-Seite" routerLink="/leistungen">{{ dataJson["LeistungenButton"]}}</a>
            </div>
        </div>
        <div class="welcomeText" >
            <h3>{{dataJson["BuerozeitenUeberschrift"]}} <b><span>{{dataJson["BuerozeitenUeberschriftStyle"]}}</span></b></h3>
            <div class="imageDiv" >
                <!-- <div class="imageDivC"  style="width: 100% ;display: flex; justify-content: center; align-items: center; flex-direction: column; overflow-y: hidden;">
                    <img data-aos="fade-up" class="openOursImage" src="./assets/img/people/Siglinde.webp" alt="">
                </div> -->
                <div style="font-weight: 200; text-align: center; padding-top: 20px;">
                    <Span><span style="color: rgb(50, 100, 50);">Montag</span> {{dataJson["ZeitMontag"]}}</Span><br>
                    <Span><span style="color: rgb(50, 100, 50);">Dienstag</span> {{dataJson["ZeitDienstag"]}}</Span><br>
                    <Span><span style="color: rgb(50, 100, 50);">Mittwoch</span> {{dataJson["ZeitMittwoch"]}}</Span><br>
                    <Span><span style="color: rgb(50, 100, 50);">Donnerstag</span> {{dataJson["ZeitDonnerstag"]}}</Span><br>
                    <Span><span style="color: rgb(50, 100, 50);">Freitag</span> {{dataJson["ZeitFreitag"]}}</Span><br>
                    <Span><span style="color: rgb(50, 100, 50);">Samstag</span> & <span style="color: rgb(50, 100, 50);">Sonntag</span> {{dataJson["ZeitWochenende"]}}</Span><br>
                </div>
            </div>
        </div>
        <app-contact-pre></app-contact-pre>
        <app-price-pre></app-price-pre>
    </div>
    
    
    
</div>